/* globals Ajax, $, Class, $H, rxSwitchboard, jui, eventTracker, LP */
var Rx = require('ub_wrapped/rx');
var jQuery = require('jquery');
var _ = require('lodash');
var React = require('react');
var ReactDOM = require('react-dom');

var ubBanzai = require('ub/control/banzai-features');
var contentTypeConfig = require('ub/content-type-config');
var editorGoals = require('ub/lp/editor/goals');
var pomValidationCleaner = require('ub/data/pomValidationCleaner');
var pomUpdates = require('ub_legacy/lp/pom/updates/updates');
var endpoints = require('ub/config/endpoints').default;
var POMValidator = require('ub/data/pom-validator').default;

var VersionControl = require('ub/ui/version-control');
var ElementCopyPaste = require('ub/ui/element_copy_paste');
var initFileDrop = require('ub/ui/file_drag_and_drop').default;
var Animate = require('ub/ui/animate');
var _safeGet = require('ub/utils').safeGet;

var pageLoadErrorAlert = require('ub/ui/alert-dialog/page-load-error').default;
var saveConflictAlert = require('ub/ui/alert-dialog/save-conflict').default;
var AlertDialog = require('ub/ui/alert-dialog');
var UnusedFormConfirmationWarning = require('ub/ui/components/unused-form-confirmation-warning').default;
var BreakpointControls = require('ub/ui/components/breakpoint-controls').default;
var InlineRootControls = require('ub/ui/components/inline-root-controls').default;
var LoginModalInstaller = require('ub/ui/login/installer').default;
var LoginModalController = require('ub/ui/login/state-controller').default;

var floatMenu = require('ub/ui/canvas/float-menu.js').default;

var rxUi = window.rxUi;

var lightboxGoalValidation = require('ub/control/lightboxGoalValidation');

var pomMetrics = require('ub/data/pom-metrics/pom-metrics');
var fontServiceManager = require('ub/fonts/font-service/manager').default;

var sandbox = require('ub/control/sandbox/sandbox');
var installAppcues = require('ub/control/app-cues').default;
var installGoogleSSO = require('ub/control/google-sso').default;

var initTooltips = require('ub/ui/tooltips').default;
var AssetLibrary = require('ui/asset-library').default;

;(function() {
  var lp = this.lp;

  var RepublishButton = require('ub/lp/editor/buttons/republish-button');
  var SaveButton = require('ub/lp/editor/buttons/save-button');
  var VersionControlButton = require('ub/lp/editor/buttons/version-control-button');

  var PageRepublisher = require('ub/lp/editor/page-republisher');

  var DialogManager  = require('ub/lp/editor/dialogs/dialog-manager');
  var PublishDialogs = require('ub/lp/editor/dialogs/publish');

  var DynamicTextModal = require('ub/ui/dynamic_text_modal');

  var AssetChooser = require('ub/lp/editor/ub-asset-chooser.js');
  var pomChangeEvs = require('ub/events/pom-change-events');

  var svgImages = require('ub/lp/editor/svg/svg.coffee');

  var isRepublishingEnabled = ubBanzai.features.isRepublishingEnabled();
  var skipExtraSwitchbreakpoint = ubBanzai.features.isSkipExtraSwitchbreakpointEnabled();

  lp.editor = lp.editor || {};

  var PagePublishObserver = require('ub/lp/editor/page-publish-observer');
  var PageSaveObserver = require('ub/lp/editor/page-save-observer');

  var installPageNavNotifier = require('ub/control/check-unsaved-nav');
  var PageTabBar = require('ub/ui/page_tab_bar');

  function enableUISettings() {
    jQuery('document').ready(function() {
      try {
        jQuery('body')
          .attr('data-ver', 'new')
          .removeAttr('data-editor')
          .attr('data-theme', ubBanzai.getFeatureValue('flatUITheme'));

        jQuery('body').attr('data-dev', 'false');

      } finally {
        jQuery('body')
          .addClass('ui-load-complete')
          .show(); // be really, really sure to show the body
      }
    });
  }

  lp.Editor = Class.create(jui.Component, lp.editor.EditorElementListeners, {
    options: function($super,options){
      return $super($H({element:'editor', attributes:{className:'lp-editor'}}).merge(options));
    },

    initialize: function($super, options) {
      enableUISettings();

      if (ubBanzai.features.isUseEditorUndoStackEnabled()) {
        this.undoManager = new jui.UndoManager();
      }

      this.controls = {};
      this.mainPage = null;
      this.pages = [];
      this.page = null;
      this.activeRoot = null;
      this.activeElement = null;
      this.activeUndoManager = null;
      this.lastSavedJSON = null;
      this.showSaveAsTemplate = options.admin && ubBanzai.features.isSaveAsTemplateEnabled();
      this.admin = options.admin;
      this.waiting = false;
      this.loadError = false;
      this.page_uuid = options.page_uuid;
      this.companies = [];
      this.currentCompanyId = null;
      this.blocked = false;
      this.savingInProgress = false;

      this.treeToggler = new lp.editor.TreeToggler(this);

      this.setUpdatedAt(options.updatedAt);
      this.createdAt = options.createdAt;

      this._createDialogManagers();

      this.copyPasteManager = new ElementCopyPaste(this);
      // must be created before $super.installUI is called
      this._uiBinding       = new rxUi.Binding('Editor');
      this._canvasUIBinding = new rxUi.Binding('Canvas');

      //
      $super(options);

      this.installThirdParties();

      var self = this;

      this.createElementListeners();

      this.undoListener = function() {
        self.setUndoStates();
      };

      this.rootLayoutListener = this.rootLayoutChanged.bind(this);

      jui.ModalPanel.addListener('modalOpened', function() {
        self.setUndoStates();
      });

      jui.ModalPanel.addListener('modalClosed', function() {
        self.setUndoStates();
      });

      this.activeElementConstraintsListener = this.activeElementConstraintsChanged.bind(this);
      this.tracePageSaves = rxSwitchboard.getPublisher('page_saves');
      this.traceEditorErrors = rxSwitchboard.getPublisher('editor_errors');
    },

    _installFloatMenu: function() {
      this.floatMenu = document.createElement('div');
      this.canvasBody.insert(this.floatMenu);

      floatMenu.setContainer(this.floatMenu);
    },

    installUI: function($super){

      //TODO: refactor
      /*jshint maxstatements:105 */
      /*jshint maxcomplexity: 12*/
      $super();
      var wrapCallback = this._uiBinding.wrapCallback;

      if(this.options.onLoaded) {
        this.addListener('loaded', this.options.onLoaded);
      }

      if(this.options.onComplete) {
        this.addListener('complete', this.options.onComplete);
      }

      this.clear();
      // TODO: We need to make this a "blacklist" instead. It's highly confusing
      // when trying to add event listeners to things other than what's listed
      // here.
      window.document.body.observe('mousedown', function(e){
        var whitelistedElements = [
          'input',
          'select',
          'textarea',
          'div[contenteditable=true]',
          'font-picker-modal-overlay',
          '.color-popdown'
        ].join(', ');

        var isWithinInlinePanel = jQuery('.inline-text-panel').has(e.target).length > 0;
        var isWithinSlider = jQuery('.slider-input').has(e.target).length > 0;

        var selectableElement = e.findElement(whitelistedElements);

        if (_.isUndefined(selectableElement) && ! isWithinInlinePanel && ! isWithinSlider) {
          Event.stop(e);
        }
      });

      var self = this;

      // Key input controller
      this.keyController = new lp.editor.KeyController(this);

      // Primary UI components
      this.toolbar = this.insert(new jui.Component({attributes:{
        id:'primary-toolbar',
        className: 'primary-toolbar'
      }}));
      this.triPane = this.insert(new jui.TriPane({attributes:{
        id: 'editor-tri-pane',
        className: 'editor-tri-pane'
      }}));

      this.pagePanel = this.triPane.setView(this.insert(
        new jui.Component({attributes:{id: 'page-panel'}})), 'center');
      this.contentPanel = this.triPane.setView(this.insert(
        new lp.editor.ContentPanel(this, {attributes:{id: 'page-content-panel', className: 'page-content-panel' }})), 'left');
      this.infoPanel = this.triPane.setView(this.insert(
        new lp.editor.InfoPanel(this, {attributes:{id: 'editor-info-panel', className:'editor-info-panel tab-view' }})), 'right');

      this.handleContentTreePaneVisibility();

      this.pageTabs = new PageTabBar(this);
      this.pagePanel.insert(this.pageTabs.rootNode);

      this.editingPanel = this.pagePanel.insert(new jui.Component({attributes:{id: 'editing-panel', className:'editing-panel'}}));

      this.componentSideBar = this.editingPanel.insert(new lp.editor.ComponentSideBar({left:true}));

      this.workArea = this.editingPanel.insert(new jui.Component({attributes:{className: 'work-area'}}));
      this.canvas = this.workArea.insert(new jui.Component({attributes:{id: 'editor-canvas', className: 'editor-canvas'}}));

      if (ubBanzai.features.isImageDragAndDropUploadEnabled()) {
        initFileDrop(window.document.body, this.canvas.e);
      }

      this.invisibleElementsShelf = this.workArea.insert(new lp.editor.NonVisibleElementsShelf(this));
      this.toggleShelf = this.invisibleElementsShelf.insert(new jui.Component({attributes:{class: 'toggle-shelf page-content-toggle footer-control'}}));

      this.insertContentTreeToggleUI();

      this.canvasBody = this.canvas.insert(
        new jui.Component({attributes:{id: 'canvas-body', className:'lp-pom-root canvas-body', 'data-role': 'viewport'}}));

      this.pageBody = this.canvasBody.insert(new jui.Component({attributes:{id: 'page-body', className:'lp-pom-body page-body'}}));

      this._installFloatMenu();

      this._installPageWarning();
      this._installWaitPanel();

      if (ubBanzai.features.isNewLoginModalEnabled()) {
        LoginModalInstaller.install(this);
      }

      if (ubBanzai.features.isNewAssetLibraryEnabled()) {
        this.assetLibrary = new AssetLibrary(this);
      }

      this.triPane.addListener('layoutChanged', this.updateCanvasLayout.bind(this));

      // NOTE: it's not clear that this can actually be triggered
      this._uiBinding.bindDOM(this.pageBody, 'click', 'setRootAsActiveElement')
        .ub_subscribe(function() {
          self.setActiveElement(self.page.getRootElement());
        });

      this.pageWarning.hide();

      // Element selection manipulation components
      this.transformBox = this.canvasBody.insert(new lp.editor.TransformBox(this));
      this.transformBox.hide();

      this.offsetIndicators = this.canvasBody.insert(new lp.editor.OffsetIndicators(this.transformBox));
      this.offsetIndicators.hide();

      // Image selection manipulation components
      this.imageTransformBox = this.canvasBody.insert(new lp.editor.ImageTransformBox(this));
      this.imageTransformBox.hide();

      this.imageOffsetIndicators = this.canvasBody.insert(new lp.editor.OffsetIndicators(this.imageTransformBox));
      this.imageOffsetIndicators.hide();

      // Page & Section manipulation components
      this.sectionTransformBox = this.canvasBody.insert(new lp.editor.SectionTransformBox(this));
      this.sectionTransformBox.hide();

      this.flashBox = new lp.editor.FlashBox(this);

      this.sectionBoundaryManager = new lp.editor.SectionBoundaryManager(this);
      this.pageBoundaryManager = new lp.editor.PageBoundaryManager(this);

      this.elementHilite = this.canvasBody.insert(new lp.editor.ElementHilite(this));
      this.elementHilite.hide();

      this.xSnapGuide = this.canvas.insert(new jui.Component({attributes:{className:'x-snap-guide'}}));
      this.xSnapGuide.hide();
      this.xSnapGuide.setOpacity(0.8);

      this.ySnapGuide = this.canvas.insert(new jui.Component({attributes:{className:'y-snap-guide'}}));
      this.ySnapGuide.hide();
      this.ySnapGuide.setOpacity(0.8);

      ReactDOM.render(
        React.createElement(InlineRootControls, {editor: this}),
        this.canvasBody.insert(document.createElement('div'))
      );

      // Sub UI components
      this.pageActionPanel = this.toolbar.insert(new jui.Component({attributes:{id: 'editor-page-action-panel' }}));

      // Buttons for action panel

      if (isRepublishingEnabled) {
        this.addListener('pageLoaded', this._installNewHeader.bind(this));
      } else {
        this.saveButton = this.pageActionPanel
          .insert( new jui.IconButton('save', {
            label:'Save',
            action:wrapCallback('save', this.save.bind(this)),
            attributes:{className:'tool-button'}}));
      }

      this.controls.undo = this.pageActionPanel.insert(
        new jui.IconButton('undo', {label:'Undo',
                                    action: wrapCallback('undo', this.undo.bind(this,-1)),
                                    attributes:{className:'tool-button svg-ico-undo'}}));

      this.controls.redo = this.pageActionPanel.insert(
        new jui.IconButton('redo', {label:'Redo',
                                    action: wrapCallback('redo', this.redo.bind(this,1)),
                                    attributes:{className:'tool-button svg-ico-redo'}}));

      this.controls.undo.disable();
      this.controls.redo.disable();

      this.controls.up = this.pageActionPanel.insert(
        new jui.IconButton('move_up',
                           {label:'Move Up',
                            action:wrapCallback('moveSectionUp', this.changeOrder.bind(this,-1)),
                            attributes:{className:'tool-button svg-ico-move-up'}}));

      this.controls.down = this.pageActionPanel.insert(
        new jui.IconButton('move_down',
                           {label:'Move Down',
                            action:wrapCallback('moveSectionDown', this.changeOrder.bind(this,1)),
                            attributes:{className:'tool-button svg-ico-move-down'}}));

      this.controls.back = this.pageActionPanel.insert(
        new jui.IconButton('back',
                           {label:'Send Backward',
                            action: wrapCallback('sendElementBackward', this.changeZIndex.bind(this,-1)),
                            attributes:{className:'tool-button svg-ico-send-backward'}}));

      this.controls.front = this.pageActionPanel.insert(
        new jui.IconButton('front',
                           {label:'Bring Forward',
                            action: wrapCallback('sendElementForward', this.changeZIndex.bind(this,1)),
                            attributes:{className:'tool-button svg-ico-bring-forward'}}));

      this.controls.copy = this.pageActionPanel.insert(new jui.IconButton('copy', {
        label: 'Copy',
        action: wrapCallback('copyElementToClipboard', this.copyPasteManager.copyElementToClipboard),
        attributes: {className: 'tool-button svg-ico-copy'}
      }));

      this.controls.paste = this.pageActionPanel.insert(new jui.IconButton('paste', {
        label: 'Paste',
        action: wrapCallback('pasteElementFromClipboard', this.copyPasteManager.pasteElementFromClipboard),
        attributes: {className: 'tool-button svg-ico-paste'}
      }));

      this.controls.duplicate = this.pageActionPanel.insert(new jui.IconButton('duplicate', {
        label:'Duplicate',
        action:wrapCallback('duplicateElement', this.duplicateElement.bind(this)),
        attributes:{
          className:'tool-button svg-ico-duplicate',
          'data-role': 'duplicateElementButton'
        }
      }));

      this.controls.remove = this.pageActionPanel.insert(
        new jui.IconButton(
          'remove', {
            label:      'Delete',
            action:     wrapCallback('deleteActiveElement', this.removeElement.bind(this)),
            attributes: {className: 'tool-button svg-ico-delete'}
          }));

      this.saveAsTemplateButton = this.pageActionPanel.insert(
        new jui.IconButton(
          'save-as-template', {
            label:      'Save as Template',
            action:     wrapCallback('saveAsTemplate', this.saveAsTemplate.bind(this)),
            attributes: {className: 'tool-button'}
          }));

      this.saveAsTemplateButton.setVisible(this.showSaveAsTemplate);

      var $saveTemplateHelp = jQuery("<a class='help-button tip-save-template'></a>");

      this.pageActionPanel.insert($saveTemplateHelp.get(0));
      if(!this.showSaveAsTemplate) { $saveTemplateHelp.hide(); }

      this.controls.widgets = [];

      this.createVisibleWidgets();

      this.updateControlStates();

      this.pageLoadErrorMessage = new jui.Component({attributes:{id: 'page-load-error-message'}});

      this._installBreakpointControls();

      this.handleToggleTree();

      this._addPreviewButtonEvent();

      if (ubBanzai.features.isSandboxEnabled()) {
        sandbox.disableHeaderBar();
        document.body.setAttribute('data-mode','sandbox');
      }

      this._fixParallaxinBuilder();

      this.animate = new Animate();

      if (ubBanzai.features.isSandboxEnabled()) {
        this.addListener('pageLoaded', this._installToolTips.bind(this));
      }else{
        this.addListener('pageLoaded', initTooltips);
      }

      this.addListener('pageLoaded', window.lp.editor.addAmpLightbox || function() {});
    },

    _installToolTips: function () {
      sandbox.initTooltips();
    },

    _installPageWarning: function() {
      this.pageWarning = this.canvasBody.insert(
        new jui.Component({
          attributes: {
            id: 'page-warning',
            className: 'page-warning unused-form-confirmation-warning'
          }
        })
      );

      var onConfirm = function() {
        var formElm = this.getFormElementOnAnyPage();
        if (formElm) {
          formElm.model.set('content.confirmAction', 'modal', this.mainPage.undoManager);
          this.pageWarning.hide();
        }
      }.bind(this);

      ReactDOM.render(
        React.createElement(UnusedFormConfirmationWarning, {onConfirm: onConfirm}),
        this.pageWarning.e
      );
    },

    _installWaitPanel: function() {
      this.waitPanel = new Element('div', {id:'wait', className: 'wait-overlay'});

        jQuery(this.waitPanel).append(
          '<div class="loading-icon"></div>'
        );

      this.waitPanel.insert(
        new Element('div', {className: 'wait-loading-image'})
          .update('<h1/>')
      );

      this.waitPanel.setOpacity(0.75);
    },

    _createDialogManagers: function() {
      this.dynamicTextDialog = null;
      this.dialogManager = new DialogManager();
    },

    readyToRepublishPageHandler: function(){
      if (localStorage.getItem('dismissPublishConfirmation') === 'true') {
        this._uiBinding.onNext({type: 'requestRepublish'});
      } else {
        this._uiBinding.onNext({type: 'readyToRepublish'});
      }
    },

    _installRepublishButton: function() {
      this.republishButton = new RepublishButton()
        .widget(
          {
            saveObs    : this.pageSaveObs.state,
            publishObs : this.pagePublishObs.state
          },
          this.readyToRepublishPageHandler.bind(this),
          { type: window.gon.page_publish_state || 'published' } // Get initial state from gon.
        )
        .init();
      return this.republishButton;
    },

    _installNewSaveButton: function() {
      this.saveControl = new SaveButton();

      this.saveButton =  this.saveControl
        .widget(
          {
            saveObs    : this.pageSaveObs.state,
            publishObs : this.pagePublishObs.state
          },
          this._uiBinding.wrapCallback('save', this.save.bind(this)),
          {type: 'pageSaveCompleted'}
        ).init();

      return this.saveButton;
    },

    _installNewHeader: function(){
      if (this.mainPage.getConfigValue('allowRepublishing')) {
        this._installRepublishButton();
      }

      this._installNewSaveButton();

      var $container = jQuery('.js-mode');

      this.versionControlButton = new VersionControlButton(
        this._uiBinding.wrapCallback('showVersionControl', this.showVersionControl.bind(this)),
        this.createdAt !== this.updatedAt,
        this.pageSaveObs.state
      );

      $container.before(this.versionControlButton.element);

      $container.before(this.saveButton);
      $container.before(this.republishButton);

      this.headerControlsRight = $container.get(0);
    },

    _fixParallaxinBuilder: function() {
      window.lp.imageUpgrader.sizeCalculationStream
        .ub_subscribe(_.bindAll(lp.editor.ParallaxFixer).runFix);
    },

    _addPreviewButtonEvent: function() {
      // Hijack the hard-coded Preview link to go to the preview of the active breakpoint
      jQuery('.preview-button-big').click(function(e) {
        e.preventDefault();

        if (ubBanzai.features.isSandboxEnabled()) {
          sandbox.showModal('preview');
        } else {
          this.preview();
        }
      }.bind(this));
    },

    insertContentTreeToggleUI: function() {
      this.toggleTreeButton = this.toggleShelf.insert(new Element('div', {
        id:'treeToggle',
        className: 'shelf-button footer-control-button'
      }));

      this.toggleTreeIndicator = this.toggleTreeButton.insert(new Element('span', {
        id: 'treeToggleIndicator',
        className: 'footer-control-toggle'
      }));

      this.toggleTreeLabel = this.toggleTreeButton.insert(new Element('a', {
        id:'treeToggleLabel',
        className: 'svg-ico-page-content'
      }).update('Contents'));

      //TODO: move these demo comment blocks into docs for rxUi.Binding
      //// first pass:
      // var eventType = 'toggleTree';
      // var clicks = rxUi.fromEvent(this.toggleTreeButton, 'click');
      // var source = clicks.map(_.constant({type: eventType}));
      // this._uiBinding.register(source)
      //   .filter(function(ev) {
      //     return ev.type === eventType;
      //   })
      //   .ub_subscribe(this.toggleTree.bind(this));

      // var eventType = 'toggleTree';
      // var clicks = rxUi.fromEvent(this.toggleTreeButton, 'click');
      // this._uiBinding.registerOnEventType(eventType, clicks)
      //   .ub_subscribe(this.toggleTree.bind(this));

      this._uiBinding.bindDOM(this.toggleTreeButton, 'click', 'toggleTree')
        .ub_subscribe(this.toggleTree.bind(this));

      this.triPane.addListener('layoutChanged', this.handleToggleTree.bind(this));
    },

    handleContentTreePaneVisibility: function() {
      if(this.treeToggler.isOpen()) {
        this.triPane.showPane('left');
      } else {
        this.triPane.hidePane('left');
      }
    },

    handleToggleTree: function() {
      if(this.triPane.panes.left.visible()) {
        $(this.toggleTreeButton).addClassName('open');
        this.treeToggler.open();
      } else {
        $(this.toggleTreeButton).removeClassName('open');
        this.treeToggler.close();
      }
    },

    toggleTree: function() {
      this.triPane.toggle('left');
    },

    _installBreakpointControls: function() {
      this.breakpointControlsContainer = this.invisibleElementsShelf
        .insert(new Element('div'))
        .addClassName('responsive-device-container push-left');

      this._uiBinding.filterByEventType('switchToBreakpoint').ub_subscribe(function(ev) {
        this.setCurrentBreakpoint(ev.breakpoint);
      }.bind(this));

      this._uiBinding.filterByEventType('setBreakpointEnabled').ub_subscribe(function(ev) {
        this.pages.forEach(function (page){
          page.setBreakpointEnabled(ev.breakpointName, ev.enabled);
        });
        this._updateBreakpointControls();
      }.bind(this));
    },

    _handleChangeBreakpoint: function(breakpointName) {
      this._uiBinding.onNext({
        type: 'switchToBreakpoint',
        breakpoint: breakpointName
      });
    },

    _handleSetBreakpointEnabled: function(breakpointName, enabled) {
      this._uiBinding.onNext({
        type: 'setBreakpointEnabled',
        breakpointName: breakpointName,
        enabled: enabled
      });
    },

    _updateBreakpointControls: function() {
      ReactDOM.render(
        React.createElement(BreakpointControls, {
          activeBreakpoint: this.page.getCurrentBreakpoint().name,
          togglingAllowed: {
            desktop: this.mainPage.getConfigValue('allowDisablingDesktopBreakpoint') &&
              ubBanzai.features.isNewBreakpointToggleEnabled(),
            mobile: ubBanzai.features.isNewBreakpointToggleEnabled()
          },
          breakpointsEnabled: {
            desktop: this.page.isDesktopEnabled(),
            mobile: this.page.isMobileEnabled(),
          },
          visible:
            (
              this.mainPage.getConfigValue('allowResponsive') ||
              ubBanzai.features.isResponsiveConvertablesEnabled()
            ) && this.mainPage.getConfigValue('showResponsiveControls'),
          onChangeBreakpoint: this._handleChangeBreakpoint.bind(this),
          onChangeBreakpointEnabled: this._handleSetBreakpointEnabled.bind(this)
        }),
        this.breakpointControlsContainer
      );
    },

    setCurrentBreakpoint: function(breakpoint) {
      this.currentBreakpoint = breakpoint;
      this.page.switchToBreakpoint(breakpoint);
    },

    getCurrentBreakpoint: function() {
      return (this.currentBreakpoint || this.page.getCurrentBreakpoint().name)
        .toLowerCase();
    },

    _shouldAddNewWidgetBadge: function(module) {
      return module.isNew;
    },

    _createWidgetLabel: function(module) {
      var $widgetContainer = jQuery('<div class="widget-label-container">');
      var labelText = module.getElementDefaults().name.replace(' ', '&nbsp;');

      $widgetContainer.append('<div class="widget-label">' + labelText + '</div>');

      return $widgetContainer[0];
    },

    createVisibleWidgets: function() {
      var self = this;
      var modules = lp.getModulesWithUsageType('page-widget'),
          elementPalletUIBinding = new rxUi.Binding('ElementPallet');

      _(modules)
        .each(function(module) {
          var button = self.componentSideBar.insert(
            new jui.Component({
              attributes:{
                className:'widget-button dnd ' + module.type + ' widget-button-' + module.type.replace("lp-pom-", "")
              }
            }))
            .update(svgImages.widgetSvg(module.type));

          button.insert(self._createWidgetLabel(module));

          if (self._shouldAddNewWidgetBadge(module)) {
            var newBadge = jQuery('<div class="widget-new-badge"><span>NEW</span></div>')[0];
            button.insert(newBadge);
          }

          Object.extend(button, jui.ControlModel);

          self.controls.widgets.push({
            type: module.type,
            button: button,
            module: module
          });

          window.lp.editor.ElementPalletDnd(module.type, button, elementPalletUIBinding);
        });

      self.updateControlStates();

      self.dynamicTextDialog = new DynamicTextModal({
        showUpsell: ! lp.isDynamicTextEnabled()
      });

      if(typeof eventTracker !== 'undefined') {
        eventTracker.track('Access the Editor', 'Editor');
      }
    },

    setUpdatedAt: function(jsonDate) {
      this.updatedAt = jsonDate;
    },

    loadPage: function(mainPageId, context) {
      var pageDataURL = endpoints.load(mainPageId);

      this.loadPageFromURL(
        pageDataURL,
        mainPageId,
        context
      );
    },

    loadPageFromURL: function(url, id, context) {
      var self = this;
      var isTestEnv = window.gon && window.gon.env === 'test';
      return new Ajax.Request(url , {
        method: 'get',
        contentType:'application/json',
        onSuccess: function onSuccess(transport) {
          var data = transport.responseJSON;
          if (!data) {return;} // empty response cannot be handled

          if($H(data).get('updated_at')) {
            self.setUpdatedAt($H(data).get('updated_at'));
          }

          var createdAt = _safeGet(data, 'created_at');

          if (createdAt) {
            self.createdAt = createdAt;
          }
          self.pageData = data;
          self.loadPageData(data, context);
          self.fireEvent('loaded', data);
          self.checkFormConfirmationDialog(data.mainPage.id, 'on load');
          self.checkFormSubmitButton(data.mainPage.id);
          self.fireEvent('complete');
        },
        onException: function(responseObj, e) {
          var transport = responseObj.transport;
          self.pageLoadError(e);

          if (console && ! isTestEnv) {
            console.log(e); //JS: please leave in. It's to aid in debugging
            console.log(e.stack);
          }

          if (transport.status !== 401) {
            // skip if logged out
            self.reportError({
              error: e,
              id: id,
              message: 'An error occurred while loading page data',
              content: transport.statusText + ': ' + transport.responseText,
              details: e.toString().truncate(300, ''), // this also gets truncated server side for hipchat but do it here anyway to limit data being sent
              userAgent: window.navigator.userAgent
            });
          }
        },
        onFailure: function(transport) {
          self.pageLoadError(null);

          if (console && ! isTestEnv) {
            console.log(transport);
          }

          if (transport.status !== 401) {
            // skip if logged out
            self.reportError({
              error: null,
              id: id,
              message: transport.statusText,
              content: transport.responseText,
              details: 'Status: ' + transport.status,
              userAgent: window.navigator.userAgent
            });
          }
        }
      });
    },

    getDynamicTextDialog: function() {
      return this.dynamicTextDialog;
    },

    showDynamicTextDialog: function(defaultText, attributes, callback) {
      this.dynamicTextDialog.open(defaultText, attributes, callback);
    },

    pageLoadError: function(error) {
      this.loadError = true;

      var webappPagesResource = contentTypeConfig
        .getValueUsingUrl('webappPagesResource', location.href);

      pageLoadErrorAlert({
        versionNewerError:
          error && error.code && error.code === LP.PAGE_VERSION_NEWER_ERR,
        displayName:
          contentTypeConfig.getValueUsingUrl('displayName', location.href),
        displayNameLowerCase:
          contentTypeConfig.getValueUsingUrl('displayNameLowerCase', location.href),
        overviewUrl:
          endpoints.overview(webappPagesResource, window.gon.client_id, this.page_uuid)
      }).safeOpen();
    },

    saveWarningDialog: function() {
      var self = this;
      this.blocked = true;

      var onClose = function() {
        // TODO: remove all uses of savingInProgress when the `republishing` feature flag is removed
        self.savingInProgress = false;

        if (ubBanzai.features.isRepublishingEnabled()) {
          // We are aborting the save - update the button state
          self.pageSaveObs.saveFailed();
        } else {
          self.saveButton.enable();
        }
        self.blocked = false;
      };

      var onSaveNewVariant = function() {
        self.dialogManager.closeCurrentDialog();
        self.saveAsNewVariant();
        self.blocked = false;
      };

      var onOverwrite = function() {
        self.dialogManager.closeCurrentDialog();
        self.forceSave();
        self.blocked = false;
      };

      var pageSupportsMultipleVariants = this.mainPage
        .getConfigValue('supportsMultipleVariants');

      saveConflictAlert(pageSupportsMultipleVariants, onClose, onSaveNewVariant, onOverwrite)
        .safeOpen();
    },

    reportError: function(error) {
      //we may not have access to the errors content at all times.
      var content = error.content ? error.content : '';
      var postBody = '<?xml version="1.0" encoding="utf-8"?>'+
        '<error>'+
          '<id>'+error.id+'</id>'+
          '<error><![CDATA['+error.error+']]></error>'+
          '<message><![CDATA['+error.message+']]></message>'+
          '<details><![CDATA['+error.details.gsub(']]>',']]]]><![CDATA[>')+']]></details>'+
          '<content><![CDATA['+content.gsub(']]>',']]]]><![CDATA[>')+']]></content>'+
          '<user_agent><![CDATA['+error.userAgent+']]></user_agent>'+
        '</error>';
      this.traceEditorErrors(error);

      return new Ajax.Request(endpoints.reportError(error.id), {
        method      : 'post',
        postBody    : postBody,
        contentType : 'application/xml'
      });
    },

    barf: function () {
      throw new Error('test error');
    },

    _allPagesFromPageData: function(pageData) {
      return  _.flatten([pageData.mainPage, pageData.subPages]);
    },

    _validatePomElements: function(pageData, label, firstRun) {
      var validations = {};

      // We only want to run validate a second time when in debug mode.
      // This will help us understand if pages are becoming corrupt through updaters
      if (ubBanzai.features.isDebugModeEnabled() || firstRun) {
        var pages = this._allPagesFromPageData(pageData);

        _.each(pages, function(page){
          var elmAndSettings = JSON.parse(JSON.stringify({elements: page.elements, settings: page.settings}));
          var validation = window.pomValidator.validate_elements_and_settings(elmAndSettings);

          if ( ! validation.valid) {
            validations[page.id] = validation;
          }

          if (ubBanzai.features.isDebugModeEnabled()) {
            console.log("VALIDATIONS: " + (validation.valid ? "Pass" : "Failed"), label, page.name, validation, page.elements, page.settings);
          }
        });
      }

      return validations;
    },

    _setupSaveAndPublishObservers: function() {
      if ( ! ubBanzai.features.isRepublishingEnabled()) { return; }

      this.pagePublishObs = new PagePublishObserver(this.currentCompanyId, this.mainPage);

      var evStream = pomChangeEvs.getEventStream();
      this.pageSaveObs = new PageSaveObserver({
        // changeObs: this._uiBinding.sink.filter(this.hasUnsavedChanges.bind(this))
        changeObs: Rx.Observable.merge(
          evStream.creationOrDeletionEventStream,
          evStream.modificationEventStream,
          evStream.blockMovedEventStream,
          evStream.pausableParentChangeEvents,
          evStream.pagePropertiesEvents,
          evStream.breakpointEvents,
          fontServiceManager.fontStorageUpdates
        )
      });

      this.pageRepublisher = new PageRepublisher(this._uiBinding, this.pagePublishObs.uiEvents);
      this.publishDialogs  = new PublishDialogs(this._uiBinding, this.pagePublishObs.state);
    },

    _addBeforeUnloadHandler: function() {
      if (ubBanzai.features.isRepublishingEnabled()) {
        installPageNavNotifier(this.pageSaveObs.state);
      } else if (ubBanzai.features.isSandboxEnabled()) {
        return;
      } else {
        //TODO: remove with republishing feature flag
        var self = this;
        window.onbeforeunload = function() {
          if (self.hasUnsavedChanges() && ! self.loadError) {
            return 'You have unsaved changes. If you leave they will be lost. ' +
              'To save them click \'Stay on this Page\', and then click ' +
              'the \'Save\' button.';
          }
        };
      }
    },

    _triggerOnPageLoadEvents: function(pageData0) {
      this.fireEvent('pageLoaded', this.mainPage);

      this.errorNotifier = lp.errorNotifier;
      this.errorNotifier.addTagsToBaseContext({
        is_admin_user: this.admin,
        page_uuid: this.mainPage.uuid
      });

      this._addBeforeUnloadHandler();

      //////////////////////////////////////////////////
      // set the initial sizing in Rx register
      this._uiBinding.onNext({
        type:'loadPage',
        pageData: pageData0,
        dimensions: this.getCurrentDimensions()
      });
    },

    loadPageData: function(pageData0, context, isRestoringFromVersionControl) {
      var pageData = _.clone(pageData0); // we want to retain an unmutated copy

      if (ubBanzai.features.isSafeModeEnabled() &&
          ubBanzai.features.isDebugModeEnabled()) {
        debugger; // jshint ignore:line
      }

      pomMetrics.run(pageData, window.lp.errorNotifier.captureMessage);

      var pomErrors = this._validatePomElements(pageData, 'before pom updates', true);

      pageData = _.isEmpty(pomErrors) ? pageData : pomValidationCleaner(pageData, pomErrors, ubBanzai.features.isDebugModeEnabled());

      pageData = pomUpdates.run(pageData);

      this._validatePomElements(pageData, 'after pom updates', false);

      this.mainPage = new lp.pom.Page(pageData.mainPage, context);

      this.unbounceCompanyId = pageData.unbounce_company_id;
      this.unbounceAssetsCompanyId = pageData.unbounce_assets_company_id;
      this.currentCompanyId = pageData.current_company_id;
      this.addPage(this.mainPage, 'top');

      pageData.subPages.each(function(subPage) {
        var page = new lp.pom.Page(_.merge({}, subPage, {
          settings: {
            mainPage: {
              variant_id : this.mainPage.variant_id,
              uuid       : this.mainPage.uuid
            }
          }
        }), context);
        this.addPage(page);
      }, this);

      this.setActivePage(this.mainPage);

      if (skipExtraSwitchbreakpoint) {
        this.mainPage.updateAndRefresh();
      }

      if ( ! isRestoringFromVersionControl) {
        this._setupSaveAndPublishObservers();
        this._triggerOnPageLoadEvents(pageData0);
      }

      this.recordPagesState();
    },

    getCurrentDimensions: function(){
      // these dimensions are required during rxUi replays
      return {
        pageBody: this.pageBody.getDimensions(),
        page: this.page.getDimensions(),
        window: {
          innerWidth: window.innerWidth,
          innerHeight: window.innerHeight
        }
      };
    },

    deletePage: function(pageToDelete) {
      var um = this.page.undoManager;
      um.startGroup();

      // Reset buttons that link to the subpage that is currently being deleted
      _(this.pages)
        .without(pageToDelete)
        .map(function(page) {
          return page.getElementsByType('lp-pom-button');
        })
        .flatten(true)
        .filter(function(buttonElm) {
          return buttonElm.model.linksToInternalLightbox() &&
            buttonElm.model.safeGet('action.lightboxId') === pageToDelete.getRefId();
        })
        .each(function(buttonElm) {
          buttonElm.model.deleteAttr('action.lightboxId', um);
        })
        .value();

      this.removePage(pageToDelete);

      um.endGroup();
    },

    _hasLightbox: function() {
      return this.findPagesUsedAs('lightbox').length > 0;
    },

    generatePageName: function(prefix) {
      var regex = new RegExp('^' + prefix + '(\ [0-9]*)?$');

      var highestNum = _(this.pages)
        .pluck('name')
        .filter(function(name) {
          return regex.test(name);
        })
        .map(function(name) {
          // If there is no number in the name, consider it '1'.
          var num = name.match(regex)[1] || 1;
          return parseInt(num, 10);
        })
        .sortBy()
        .last();

      return highestNum ? prefix + ' ' + (highestNum + 1) : prefix;
    },

    _addPageListeners: function(page) {
      page.addListener('elementInserted', this);
      page.addListener('elementRemoved', this);
      page.addListener('pageUpdatedAndRefreshed', this);
      page.addListener('beforeBreakpointChanged', this);
      page.addListener('breakpointChanged', this);
    },

    _removePageListeners: function(page) {
      page.removeListener('elementInserted', this);
      page.removeListener('elementRemoved', this);
      page.removeListener('pageUpdatedAndRefreshed', this);
      page.removeListener('beforeBreakpointChanged', this);
      page.removeListener('breakpointChanged', this);
    },

    addPage: function(page, position) {
      if (page && page.isLightbox() && this.page) {
        // The existing implementation of form confirmation dialog pages depends on
        // addPage not being registered as an undo. However, adding a *lightbox* is a
        // user-initiated action that we do want to register as an undo.
        this.page.undoManager.registerUndo({
          action   : this.removePage,
          receiver : this,
          params   : [page]
        });
      }

      this.pages.push(page);

      page.elements.each(function(elm){
        this.addElementListeners(elm);
        if(elm.type === 'lp-pom-form') {
          page.has_form = true;
        }
      }, this);

      this._addPageListeners(page);

      this.pageTabs.addPage(page, position);

      page.getRootElement().model.set('mainPagePublishedUrl', this.mainPage.page.published_url);

      // Update the `hasLightbox` settings flag, used by webapp
      this.mainPage.settings.hasLightbox = this._hasLightbox();
      this.updateControlStates();
    },

    removePageListenersAndTabs: function(page) {
      page.elements.each(function(elm){
        this.removeElementListeners(elm);
      }, this);

      this._removePageListeners(page);

      this.pageTabs.removePage(page);
      this.pages = this.pages.without(page);
    },

    removePage: function(page) {
      var undoManager = this.page.undoManager;
      undoManager.startGroup();
      undoManager.registerUndo({
        action: this.addPage,
        receiver: this,
        params: [page]
      });

      // When a page containing a form is removed, ensure that the form's confirmation
      // dialog is removed too.
      page.removeForm();

      this.removePageListenersAndTabs(page);

      // If we are on a page that was removed, switch to the main page.
      if ( ! _.contains(this.pages, this.page)) {
        this.setActivePage(this.mainPage);
      }

      if(page.isLightbox()) {
        this.showLightboxLimitNotice = false;
      }

      // Update the `hasLightbox` settings flag, used by webapp
      this.mainPage.settings.hasLightbox = this._hasLightbox();
      undoManager.endGroup();
    },

    findPageByRefId: function(id) {
      return this.pages.find(function(page) {
        return page.getRefId() === id;
      });
    },

    findPagesUsedAs: function(usedAs) {
      return this.pages.findAll(function(page) {
        return page.page.used_as === usedAs;
      });
    },

    setActivePage: function(page) {
      if (page === this.page) {
        return; // don't change page when already there
      }

      if (!page) {
        var e = new TypeError('setActivePage requires a valid page argument');
        this.reportError({
          error:e,
          id: this.mainPage.id,
          message: 'editor.setActivePage passed undefined/null',
          details: 'editor.setActivePage passed undefined/null',
          userAgent: window.navigator.userAgent
        });
        return;
      }
      var previous = this.page;
      if (previous !== null) {
       previous.scrollPosition = this.canvasBody.e.scrollTop;
      }

      this.page = page;

      lp.pom.NewBGPropsUpgrader.updateOldPropsToNewProps();
      window.lp.imageUpgrader.upgrade();

      this.updateCanvasLayout();
      this._updateBreakpointControls();

      var formElm = this.getFormElementOnAnyPage();
      var confirmAction = formElm ? formElm.model.safeGet('content.confirmAction') : '';

      if (formElm && page.isFormConfirmation() && confirmAction !== 'modal') {
        this.pageWarning.show();
      } else {
        this.pageWarning.hide();
      }

      if ( ! page.hasBeenViewed()) {
        page.markAsViewed();
      }

      this.fireEvent('beforeActivePageChanged', {previous: previous});
      page.insertPage(this.pageBody);
      this.fireEvent('activePageChanged', {current: page, previous: previous});
      this.setActiveUndoManager(page.undoManager);
      this.setActiveRoot(page.getRootElement());

      this.canvasBody.e.scrollTop = page.scrollPosition || 0;
      if (skipExtraSwitchbreakpoint) {
        // experimental removal of redundant calls to switchToBreakpoint
        var bp = this.getCurrentBreakpoint();
        if ( _.isEmpty(this.page.currentBreakpoint) || this.page.currentBreakpoint.name !== bp) {
          this.page.switchToBreakpoint(this.getCurrentBreakpoint());
        }
      } else {
        this.page.switchToBreakpoint(this.getCurrentBreakpoint());
      }
    },

    getFormElementOnAnyPage: function() {
      return _(this.pages)
        .map(function(page) {
          return page.getElementsByType('lp-pom-form');
        })
        .flatten(true)
        .value()[0];
    },

    isPageActive: function(page) {
      return this.page && this.page.getRefId() === page.getRefId();
    },

    anyPageHasForm: function() {
      return _.any(this.pages, function(page) {
        return page.hasForm();
      });
    },

    hasButtonLinkedTo: function(pageRefId) {
      return _.any(this.pages, function(page) {
        return _.any(page.getElementsByType('lp-pom-button'), function(btn) {
          return btn.model.safeGet('action.lightboxId') === pageRefId;
        });
      });
    },

    setActiveUndoManager: function(undoManager) {
      if (this.activeUndoManager !== null) {
        this.activeUndoManager.removeListener('undoRegistered', this.undoListener);
        this.activeUndoManager.removeListener('undoPerformed', this.undoListener);
        this.activeUndoManager.removeListener('redoPerformed', this.undoListener);
      }

      this.activeUndoManager = undoManager;
      this.activeUndoManager.addListener('undoRegistered', this.undoListener);
      this.activeUndoManager.addListener('undoPerformed', this.undoListener);
      this.activeUndoManager.addListener('redoPerformed', this.undoListener);
      this.setUndoStates();
    },

    setActiveRoot: function(elm) {
      var previous = this.activeRoot;
      if (previous !== null) {
        previous.removeListener('layoutChanged', this.rootLayoutListener);
        previous.model.removeListener('attributeChanged', this.rootLayoutListener);
        previous.view.remove();
      }

      this.activeRoot = elm;
      this.activeRoot.addListener('layoutChanged', this.rootLayoutListener);
      this.activeRoot.model.addListener('attributeChanged', this.rootLayoutListener);

      this.setActiveElement(elm);
      this.fireEvent('activeRootChanged', {current:elm, previous:previous});
    },

    activeElementConstraintsChanged: function(){
      this.updateControlStates();
    },

    setActiveElement: function(elm, forceSetActive) {
      if (this.activeElement === elm && !forceSetActive) {
        return;
      }

      if (this.activeElement !== null) {
        this.activeElement.removeElementShadow();

        this.activeElement.deactivate();
        this.fireEvent( 'elementDeactivated', this.activeElement);
      }

      this.deactivateCurrentActiveElement();

      if (elm && ! _.contains(['lp-pom-root', 'lp-pom-block'], elm.type)) {
        elm.addElementShadow();
      }

      this.activateCurrentElement(elm);

      if (elm === null) {
        return;
      }

      this.activeElement.addListener(
        'elementConstraintsChanged',
        this.activeElementConstraintsListener
      );

      elm.activate();

      this.fireEvent('elementActivated', elm);

      if (this.activeElement.is('displayable') || this.activeElement.type !== 'lp-pom-root') {
        this.scrollToElement(elm);
        this.flashBox.flash(elm);
      }

      floatMenu.subject.onNext();
    },

    activateCurrentElement: function(elm) {
      this.activeElement = elm;
      this.updateControlStates();
    },

    deactivateCurrentActiveElement: function() {
      if(this.activeElement) {
        this.activeElement.removeListener(
          'elementConstraintsChanged',
          this.activeElementConstraintsListener
        );
      }
    },

    _showCanvasAsModal: function() {
      var shouldShowAsModalOnMainPage =
        this.page.isMain() &&
        this.mainPage.getConfigValue('showMainPageCanvasAsModal');

      var shouldShowAsModalOnSecondaryPage =
        ! this.page.isMain() &&
        this.mainPage.getConfigValue('showSecondaryPageCanvasAsModal');

      return shouldShowAsModalOnMainPage || shouldShowAsModalOnSecondaryPage;
    },

    updateCanvasLayout: function() {
      var showCanvasAsModal = this._showCanvasAsModal();
      var showRootBackground = this.mainPage.getConfigValue('showRootBackground');

      var pageDimensions = this.page.getDimensions();
      var canvasDimensions = this.pageBody.getDimensions();
      var rootElement = this.page.getRootElement();
      var mainPageRootElement = this.mainPage.getRootElement();

      if (showCanvasAsModal) {
        this.canvasBody.e.addClassName('modal');
        rootElement.view.setWidth(pageDimensions.width);
        rootElement.view.setOffset({
          left: Math.max(20, (this.canvasBody.getWidth() - pageDimensions.width) / 2),
          top: 32,
        });
      } else {
        this.canvasBody.e.removeClassName('modal');
        rootElement.view.setWidth(canvasDimensions.width);
        rootElement.view.setOffset({
          left: 0,
          top: mainPageRootElement.isDisplayPositionBottom() ?
            Math.max(100, canvasDimensions.height - pageDimensions.height - 1) : 0,
        });
      }

      if (showRootBackground) {
        this.canvasBody.e.removeClassName('no-background');
      } else {
        this.canvasBody.e.addClassName('no-background');
      }

      var w = Math.max((this.page.getContentWidth() + 40), this.canvasBody.e.clientWidth);

      this.pageBody.setWidth(w);

      if ( ! showCanvasAsModal) {
        this.page.getRootElement().view.setWidth(w);
      }

      this.fireEvent('layoutChanged');
    },

    recordPagesState: function() {
      this.lastSavedJSON = '';
      this.pages.each( function(page) {
         this.lastSavedJSON += Object.toJSON(page.toJSO());
      }, this);
    },

    hasUnsavedChanges: function() {
      if(!this.mainPage) { return false; }
      var current = this.pages.map(function jsonifyJSO(page){
        return Object.toJSON(page.toJSO());
      }).join('');
      return current !== this.lastSavedJSON;
    },

    forceSave: function() {
      this.sendSaveRequest(true);
    },

    save: function() {
      if (ubBanzai.features.isSandboxEnabled()) {
        return;
      }

      // Check to see if saving is blocked.  This is to prevent save from being
      // called again if we are waiting for user input such as when there is a
      // save conflict.
      if ( ! this.blocked && ! this.savingInProgress) {
        if (ubBanzai.features.isRepublishingEnabled()) {
          this.pageSaveObs.saving();

          // When the page save initates, we switch to the form confirmation and back.
          // This initiates the parallax fixer which blocks the browser before the button
          // has changed to its 'Saving...' state, causing a noticable lag. Setting a
          // short timeout ensures that the button changes state *before* initiating the
          // save and blocking the browser. LP-8272.
          var self = this;
          window.setTimeout(function() {
            self.sendSaveRequest(false);
          }, 10);

        } else {
          this.sendSaveRequest(false);
        }
      }
    },

    saveAsNewVariant: function() {
      var self = this;
      this.postSaveData(
        endpoints.saveAsNewVariant(this.mainPage.id),
        this.mainPage.id,
        this.buildSaveData(),
        function(transport) {
          self.savingInProgress = false;

          if (ubBanzai.features.isRepublishingEnabled()) {
            self.pageSaveObs.saveCompleted();
          }

          window.location.href = transport.responseJSON.new_variant_url;
        }
      );
    },

    _updateSubpagesWithIds: function(subPageIdMappings) {
      // On the first save after a subpage has been created, the webapp responds with the
      // new subpage's ID. This method updates the corresponding builder page object with
      // that ID.
      var self = this;
      _(subPageIdMappings)
        .reject(_.isEmpty)
        .each(function(subPageIdMapping){
          var tempId    = _.keys(subPageIdMapping)[0];
          var pageRefId = parseInt(tempId.replace(/temp_id_/, ''), 10);
          var subPage   = self.findPageByRefId(pageRefId);
          if (subPage) {
            var ids         = _.values(subPageIdMapping)[0];
            subPage.page.id = ids.page_id;
            subPage.id      = ids.page_variant_id;
          }
        })
        .value();
    },

    sendSaveRequest: function(forceSave) {
      POMValidator.validatePOM(lp, window.editor.pages);
      lightboxGoalValidation.validateLightboxPageGoals(this);

      var self = this;

      document.activeElement.blur();

      this.errorMsg = 'There was a problem saving your changes. Please try again.';
      this.savingInProgress = true;

      if (ubBanzai.features.isRepublishingEnabled()) {
        this.pageSaveObs.saving();
      } else {
        this.saveButton.disable();
        this.saveButton.pulse(250, 0.75);
        this.saveButton.setLabel('Saving...');
      }

      var saveEndpoint = endpoints.save(
        this.mainPage.getConfigValue('webappVariantsResource'), this.mainPage.id);

      try {
        this.prepareModulesForSave(this.mainPage.id);
        this.validateTitleTag();
        this.postSaveData(
          saveEndpoint,
          this.mainPage.id,
          this.buildSaveData(forceSave),
          function (transport) {
            var json = transport.responseJSON;

            if (json.updated_at) {
              self.setUpdatedAt(json.updated_at);
              delete json.updated_at;
            }

            if (json.created_at) {
              self.createdAt = json.created_at;
            }

            // The presence of the sub_pages field indicates we're using the new extended
            // subpages/lightbox webapp code and might have multiple subpages. e.g.:
            // {"sub_pages":[{"temp_id_1":{"page_id":16332,"page_variant_id":17292}}]}
            // Otherwise we're receiving an old style single subpage (form conf only)
            // response from the webapp. e.g.:
            // {"temp_id_1":{"page_id":16332,"page_variant_id":17292}}
            var subPageIdMappings = json.sub_pages ? json.sub_pages : [json];
            self._updateSubpagesWithIds(subPageIdMappings);

            self.savingInProgress = false;

            if (ubBanzai.features.isRepublishingEnabled()) {
              self.pageSaveObs.saveCompleted();
            }
          }
        );

        this.recordPagesState();

      } catch(e) {
        this.savingInProgress = false;

        if (! ubBanzai.features.isRepublishingEnabled()) {
          this.reenableSave();
        } else {
          self.pageSaveObs.saveFailed();
        }

        new AlertDialog({
          title: 'Saving ' + this.mainPage.getConfigValue('displayName'),
          message: this.errorMsg,
          icon: 'error'
        }).safeOpen();

        var message = e.message ? e.message + ': ' : '';
        message += e.stack ? e.stack.toString() : '';
        console.log(message);
        this.reportError({
          error: e,
          id: this.mainPage.id,
          message: message,
          details: 'Problems Saving!',
          userAgent: window.navigator.userAgent
        });
      }
    },

    validateTitleTag: function() {
      var title = window.editor.page.metaData.title;
      if(title.length > 4000) {
        this.errorMsg = this.errorMsg +=
          '\n\nToo many characters were used in the page properties title.';
        throw new Error('TitleTooLongError');
      }
    },

    showVersionControl: function() {
      if (ubBanzai.features.isSandboxEnabled()) { return; }

      this.versionControl = this.versionControl || new VersionControl(this);
      this.versionControl.showDialog();
    },

    saveAsTemplate: function() {
      var self = this;
      var saveEndpoint = endpoints.saveAsTemplate(
        this.mainPage.getConfigValue('webappTemplatesResource'), this.currentCompanyId);

      this.saveAsTemplateButton.disable();
      this.postSaveData(
        saveEndpoint,
        this.mainPage.id,
        this.buildSaveData(),
        function(/* transport */) {
          self.saveAsTemplateButton.enable();
          self.savingInProgress = false;

          if (ubBanzai.features.isRepublishingEnabled()) {
            self.pageSaveObs.saveCompleted();
          }
        }
      );
    },

    buildSaveData: function(forceSave) {
      editorGoals.updateAndSyncGoals(this);

      this.pages.forEach(function(page) {
        page.prepareForSave(this);
      }.bind(this));

      var mainPageXML  = this.mainPage.toXML(),
          subPagesXML  = '',
          forceSaveStr = forceSave ?  '<force_save>true</force_save>' : '';

      this.pages.without(this.mainPage).each( function(subPage) {
        subPagesXML += subPage.toXML();
      });

      return '<?xml version="1.0" encoding="utf-8"?>'+
        '<data>'+
          '<main_page>'+mainPageXML+'</main_page>'+
          '<sub_pages>'+subPagesXML+'</sub_pages>'+
          '<updated_at>'+this.updatedAt+'</updated_at>'+
          forceSaveStr +
        '</data>';
    },

    prepareModulesForSave: function(id) {
      this.checkFormSubmitButton(id);
      this.checkFormConfirmationDialog(id, 'during save');
    },

    checkFormConfirmationDialog: function(id, when) {
      var form = this.page.getForm();
      if (form && this.findPagesUsedAs('form_confirmation').length < 1) {
        form.createConfirmationPage();

        var message = 'Missing form confirmation dialog detected and fixed ' + when;
        lp.errorNotifier.captureMessage(message, {
          tags: {form_action: form.model.safeGet('content.confirmAction')}
        });
      }
    },

    checkFormSubmitButton: function(id) {
      var form = this.page.getForm();

      if(form && form.isFormMissingSubmitButton()) {
        form.reAddMissingSubmitButton();

        this.reportError({
          error     : '',
          id        : id,
          message   : 'A form was detected without a submit button and fixed.',
          details   : 'Form missing Submit button error',
          userAgent : window.navigator.userAgent
        });
      } else if(form && !form.isButtonAttached()) {
        var details = 'The from action was -' + form.submitButtonAction();
        form.reattachDetachedSubmitButton();
        this.reportError({
          error     : '',
          id        : id,
          message   : 'A detached form button has been detected and fixed. ' + details,
          details   : 'Detached Form Error',
          userAgent : window.navigator.userAgent
        });
      }
    },

    reenableSave: function() {
      this.saveButton.stopPulse();
      this.saveButton.enable();
      this.saveButton.setLabel('Save');
      this.savingInProgress = false;
    },

    buildSaveDataJSON: function() {
      var subPagesJSO =
        _(this.pages)
        .without(this.mainPage)
        .map(function(page) {
          return page.toFullJSO();
        }).value();

      return {
        mainPage: this.mainPage.toFullJSO(),
        subPages: subPagesJSO
      };
    },

    //TODO: should push error states for the save button?
    postSaveData: function(url, id, data, completeAction) {
      this.tracePageSaves({id:id, url:url, data:this.buildSaveDataJSON()});
      var self = this;
      var timeStamp;

      lp.incrementSessionId();
      return new Ajax.Request(url, {
        method: 'post',
        postBody: data,
        contentType: 'application/xml',
        onCreate: function() {
          timeStamp = new Date().getTime();
        },
        onComplete: function(){
          //Moved these into onComplete so they happen regardless if
          //the save fails or not.
          if (! ubBanzai.features.isRepublishingEnabled()) {
            self.reenableSave();
          }
        },
        onSuccess: completeAction,
        onFailure: function(transport) {
          self.savingInProgress = false;

          if (ubBanzai.features.isRepublishingEnabled()) {
            self.pageSaveObs.saveFailed();
          } else {
            self.saveButton.enable();
          }

          var saveAlert = new AlertDialog({
            title: 'Saving ' + self.mainPage.getConfigValue('displayName'),
            message: 'There was a problem saving your changes. Please try again.',
            icon: 'error'
          });

          if (transport.status === 401 && ubBanzai.features.isNewLoginModalEnabled()) {
            LoginModalController.notifySessionExpire(transport.status);
          } else if (transport.status === 401) {
            saveAlert.safeOpen();
          } else {
            saveAlert.safeOpen();
            // Logged out (unauthorized) errors are handled by the webapp so we don't send
            // those to sentry
            var msg = 'Problem attempting to save: ' + transport.statusText;
            var e = new Error(msg); // for better reporting in sentry
            self.reportError({
              error     : e,
              id        : id,
              message   : msg,
              content   : transport.responseText,
              details   : 'Status: ' + transport.status,
              userAgent : window.navigator.userAgent,
              timeTaken : (new Date().getTime() - timeStamp) / 1000
            });
          }
        },

        on0: function() {
          self.savingInProgress = false;

          if (ubBanzai.features.isRepublishingEnabled()) {
            self.pageSaveObs.saveFailed();
          }

          new AlertDialog({
            title: 'Saving ' + self.mainPage.getConfigValue('displayName'),
            message: 'Sorry, we could not save your page.',
            secondaryMessage: 'Please check your internet connection and try again.',
            icon: 'error'
          }).safeOpen();
        },
        on409: function() {
          self.saveWarningDialog();
        }
      });
    },

    /* JS: TODO: This doesn't work when previewing a tempate */
    preview: function() {
      if (this.mainPage) {
        var previewURL = endpoints.preview(
          this.mainPage.getConfigValue('webappPagesResource'),
          this.currentCompanyId,
          this.mainPage.uuid,
          this.mainPage.id,
          this.page.currentBreakpoint.name
        );

        window.open(previewURL, '_blank');
      }
    },

    undo: function() {
      if (this.activeUndoManager.canUndo() && !jui.ModalPanel.isModalOpen()) {
        this.page.undoManager.undo();
      }
    },

    redo: function() {
      if (this.activeUndoManager.canRedo() && !jui.ModalPanel.isModalOpen()) {
        this.page.undoManager.redo();
      }
    },

    addScript: function() {
      lp.getModule('lp-script');
    },

    addStylesheet: function() {
      lp.getModule('lp-stylesheet');
    },

    openAssetChooser: function(options) {
      if (ubBanzai.features.isNewAssetLibraryEnabled()) {
        this.assetLibrary.open(options);
      } else {
        this.assetChooser = new AssetChooser();
        var self = this;
        this.assetChooser.addListener('modalPanelClosed', function() {
          self.assetChooser.assetBrowser._uiBinding.dispose();
          _.each(self.assetChooser.assetBrowser.getViews(), function(view) {
            view._uiBinding.dispose();
          });
          self.assetChooser._uiBinding.dispose();
        });
        this.assetChooser.open(options);
      }
    },

    isMovingForward: function(direction) {
      return direction === 1;
    },

    isMovingBackward: function(direction) {
      return direction === -1;
    },

    _getClosestElementsZIndex: function() {
      var overlappingElements = this._findOverlappingElements();
      var activeElmZIndex = this.activeElement.model.getZIndex();
      var closestAbove = null;
      var closestBelow = null;

      _.each(overlappingElements, function(elm) {
        var elmZIndex = elm.model.getZIndex();

        if (elmZIndex > activeElmZIndex) {
          if ( ! closestAbove || (elmZIndex < closestAbove)) {
            closestAbove = elmZIndex;
          }
        } else {
          if ( ! closestBelow || (elmZIndex > closestBelow)) {
            closestBelow = elmZIndex;
          }
        }
      });

      return {above: closestAbove, below: closestBelow};
    },

    _getNewZIndex: function(direction) {
      var closestElms = this._getClosestElementsZIndex();

      if (this.isMovingForward(direction)) {
        if ( ! closestElms.above) {
          return this.activeElement.view.getZIndex();
        } else {
          var currentElmAtZIndex = this.page.getElementByZIndex(closestElms.above);

          // This check is done to increment by the z-index of any nested child elements
          if (currentElmAtZIndex) {
            return currentElmAtZIndex.getMaxZIndex() + direction;
          }

          return direction + closestElms.above;
        }

      } else if (this.isMovingBackward(direction)) {
        if ( ! closestElms.below) {
          return this.activeElement.view.getZIndex();
        } else {
          return closestElms.below;
        }
      }
    },

    triggerPopupAnimation: function(elm, popDirection) {
      var initialScale = 1.0;
      var existingScale = elm.model.safeGet('geometry.scale');
      var duration = 300;

      if (existingScale) {
        initialScale = JSON.parse(existingScale);
      }

      this.animate.stopAllAnimations();

      if (popDirection === 'up') {
        this.animate.scaleAnimation(elm, initialScale, 0)
        .scaleAnimation(elm, initialScale + 0.03, duration * 0.2)
        .scaleAnimation(elm, initialScale - 0.025, duration * 0.3)
        .scaleAnimation(elm, initialScale, duration * 0.5);
      } else if (popDirection === 'down') {
        this.animate.scaleAnimation(elm, initialScale, 0)
        .scaleAnimation(elm, initialScale - 0.03, duration * 0.2)
        .scaleAnimation(elm, initialScale + 0.025, duration * 0.3)
        .scaleAnimation(elm, initialScale, duration * 0.5);
      }
    },

    changeZIndex: function(direction) {
      // jshint maxcomplexity: 12
      var activeElement = this.activeElement;

      var isInvalidElm = activeElement === null ||
        activeElement.parentElement === null ||
        activeElement === this.page.getRootElement() ||
        ! activeElement.is('z_indexable');

      var isElmAtFront = this.isMovingForward(direction) &&
        activeElement.parentElement.getLastElementByZIndex() === activeElement;

      var isElmAtBack = this.isMovingBackward(direction) &&
        activeElement.parentElement.getFirstElementByZIndex() === activeElement;

      if (isInvalidElm || isElmAtFront || isElmAtBack) {
        return;
      }

      if(this.isMovingForward(direction)) {
        this.triggerPopupAnimation(activeElement, 'up');

      } else if (this.isMovingBackward(direction)) {
        this.triggerPopupAnimation(activeElement, 'down');
      }

      var parentElm = this._getZIndexParent(activeElement);
      var newZIndex = this._getNewZIndex(direction);

      // If the z-index remains the same, use the old method of swapping z-indexs
      if (newZIndex === this.activeElement.view.getZIndex()) {
        activeElement.changeZIndex(direction);
      } else {
        parentElm.insertZIndex(newZIndex, 1);
        activeElement.model.setZIndex(newZIndex);
        this.page.getRootElement().compactZIndexes();

        activeElement.fireEvent('zIndexChanged');
      }
    },

    changeOrder: function(direction) {
      // JS: TODO: this logic should probably be used to enable/disable buttons
      if (this.activeElement === null ||
          this.activeElement === this.page.getRootElement() ||
          !this.activeElement.is('displayable') ||
          !this.activeElement.is('orderable')) {
        return;
      }

      this.activeElement.getParentElement().changeOrder(this.activeElement, direction);
    },

    _getZIndexParent: function(elm) {
      var parentElm = elm.getParentElement();

      if (parentElm.type === 'lp-pom-block') {
        parentElm = this.page.getRootElement();
      }

      return parentElm;
    },

    _findOverlappingElements: function() {
      var activeElement = this.activeElement;
      var activeElmTop =  activeElement.view.getTop();
      var activeElmLeft = activeElement.view.getLeft();
      var activeElmBottom = activeElmTop + activeElement.view.getHeight();
      var activeElmRight = activeElmLeft+ activeElement.view.getWidth();
      var activeElmParent = this._getZIndexParent(activeElement);

      return _.filter(this.page.elements, function(elm) {
        if ( ! elm._attached) {
          return false;
        }

        var isValidElement = ! _.contains(['lp-pom-root', 'lp-pom-block'], elm.type) &&
                            elm.view.visible && elm.id !== activeElement.id;

        var elmParent = this._getZIndexParent(elm);
        var isSameParent = elmParent.id === activeElmParent.id;

        var elmTop = elm.view.getTop();
        var elmLeft = elm.view.getLeft();
        var elmBottom = elmTop + elm.view.getHeight();
        var elmRight = elmLeft + elm.view.getWidth();

        return isValidElement &&
              isSameParent &&
              (elmTop < activeElmBottom) && (elmBottom > activeElmTop) &&
              (elmLeft < activeElmRight) && (elmRight > activeElmLeft);
      }, this);
    },

    removeElement: function() {
      if (!this.activeElement.is('removable')) {
        return;
      }

      var self = this;
      var removeFunc = function() {
        if(self.activeELement === null){
          return;
        }

        self.page.undoManager.startGroup();
        self.activeElement.removeFromPage();
        self.page.undoManager.endGroup();
      };

      if (typeof this.activeElement.handleRemoval !== 'function' || !this.activeElement.handleRemoval(removeFunc)) {
        removeFunc();
      }
    },

    duplicateElement: function() {
      var activeEl = this.activeElement
        , page     = this.page;

      if(activeEl === null || !activeEl.isCopyable()){
        return;
      }

      function calculateOffset(offset) {
        return {'left' : offset.left + 10,
                'top'  : offset.top  + 10};
      }

      page.undoManager.startGroup();

      var cloneEl     = activeEl.clone()
        , cloneModel  = cloneEl.model
        , activeModel = activeEl.model;
      if (cloneModel.exists('geometry.offset') && cloneEl.type !== 'lp-pom-block') {
        // set offset for all breakpoints breakpoints
        var otherBreakpoints = _.without(
            page.getBreakPoints(),
            page.getCurrentBreakpoint());

        _.map(otherBreakpoints, function(breakpoint) {
          cloneModel.setOffsetByBreakpoint(
              calculateOffset(activeModel.getReadableModel(breakpoint).geometry.offset),
              breakpoint);
        });
        // set offset for current breakpoint
        cloneModel.setOffset(calculateOffset(activeModel.getOffset()));
      }

      if (activeEl.type === 'lp-multi-select') {
        page.undoManager.registerUndo({
          action   : this.setActiveElement,
          receiver : this,
          params   : [page.getRootElement()]
        });
      }

      cloneEl.updateElementTreeOnInsert = true;
      this.setActiveElement(cloneEl);
      this.fireEvent('elementDuplicated', cloneEl);

      page.undoManager.endGroup();
    },

    elementInserted: function(e) {
      var elm = e.data;
      this.addElementListeners(elm);

      if (elm.activateOnInsert && elm.getRootElement() === this.activeRoot) {
        this.setActiveElement(elm);
      }

      this.updateControlStates();
      editorGoals.updateAndSyncGoals(this);
      this.fireEvent('elementInserted', elm);
    },

    elementRemoved: function(e) {
      var elm = e.data.element;
      this.removeElementListeners(elm);

      if (this.activeElement === elm){
        this.controls.remove.disable();
        this.controls.duplicate.disable();
        this.setActiveElement(null);
      }

      this.updateControlStates();
      editorGoals.updateAndSyncGoals(this);
      this.fireEvent('elementRemoved', e.data);
    },

    rootLayoutChanged: function() {
      this.updateCanvasLayout();
    },

    editModal: function(id) {
      this.setActiveRoot(this.page.getElementById(id).getRootElement());
    },

    updateControlStates: function() {
      var elm = this.activeElement;
      var baseCriteria = elm !== null && elm.type !== 'lp-pom-root' && elm.parentElement !== null;

      this.controls.copy.setEnabled(this.copyPasteManager.isElemCopyable(elm));
      this.controls.copy.setLabel('Copy');
      this.controls.copy.stopPulse();
      this.controls.paste.setEnabled(this.copyPasteManager.isElemAvailableToPaste(elm));

      this.controls.remove.setEnabled(baseCriteria && elm.is('removable'));
      this.controls.duplicate.setEnabled(baseCriteria && elm.isCopyable());

      this._updateWidgetStates();

      this.controls.back.setEnabled(baseCriteria && elm.is('z_indexable') && elm.parentElement.getFirstElementByZIndex() !== elm);
      this.controls.front.setEnabled(baseCriteria && elm.is('z_indexable') && elm.parentElement.getLastElementByZIndex() !== elm);

      var children = baseCriteria ? elm.parentElement.childElements : [];
      var upable = children.length > 1 && children.first() !== elm;
      var downable = children.length > 1 && children.last() !== elm;

      this.controls.up.setEnabled(baseCriteria && elm.is('displayable') && elm.is('orderable') && upable);
      this.controls.down.setEnabled(baseCriteria && elm.is('displayable') && elm.is('orderable') && downable);
    },

    _updateWidgetStates: function() {
      var self = this;

      var shouldShowWidget = function(module) {
        return !self.mainPage || module.isAllowedOnPage(self.mainPage);
      };

      var shouldEnableWidget = function(module) {
        if (self.page === null) {
          return false;
        }

        // On an empty page only allow sections to be inserted
        if (! self.page.hasContent() && module.type !== 'lp-pom-block') {
          return false;
        }

        // Prevent multiple forms from being added
        if (module.type === 'lp-pom-form' &&
            (! self.page.allowForm() || self.anyPageHasForm())) {
          return false;
        }

        // If only one internal lightbox is allowed, don't allow lightbox buttons to be
        // added to that one lightbox - because there are no other lightboxes to link to
        if (module.type === 'lp-pom-lightbox-button' &&
            ubBanzai.getFeatureValue('lightboxLimit') === 1 && self.page.isLightbox()) {
          return false;
        }

        // Enforce a limit on how many of each module can exist on the page
        if (self.page.isModuleAtLimit(module)) {
          return false;
        }

        return true;
      };

      this.controls.widgets.each(function(widget) {
        widget.button.setVisible(shouldShowWidget(widget.module));
        widget.button.setEnabled(shouldEnableWidget(widget.module));
      }, this);
    },

    setUndoStates: function() {
      this.controls.undo.setEnabled(!this.loadError && this.activeUndoManager.canUndo() && !jui.ModalPanel.isModalOpen());
      this.controls.redo.setEnabled(!this.loadError && this.activeUndoManager.canRedo() && !jui.ModalPanel.isModalOpen());
    },

    scrollToElement: function(elm) {
      if (!elm.is('displayable') || elm.type === 'lp-pom-root') {
        return;
      }

      var offset = elm.getPageOffset();
      var size = elm.model.getSize();
      var canvasSize = this.canvasBody.getDimensions();
      var scrollTop = this.canvasBody.e.scrollTop;

      if (offset.top > canvasSize.height + scrollTop || offset.top + size.height < scrollTop) {
        var scrollTo = (offset.top < scrollTop) ?
          offset.top :
          ((offset.top + size.height - scrollTop) > canvasSize.height) ?
            Math.max(offset.top + size.height - canvasSize.height, 0) :
            scrollTop;

        if (scrollTop !== scrollTo) {
          this.canvasBody.e.scrollTop = scrollTo;
        }
      }
    },

    elementSelected: function(e){
      var elm = e.data;
      this.setActiveElement(elm);
    },

    wait: function(message) {
      if (this.waiting) {
        return;
      }

      this.waitPanel.querySelector('h1').innerText = message ? message.message : 'Please wait while the image loads...';

      this.waiting = true;
      this.insert(this.waitPanel);
    },

    stopWaiting: function() {
      if ( ! this.waiting) {
        return;
      }

      this.waiting = false;
      this.waitPanel.remove();
    },

    snappedToContainer: function(e) {
      if ( ! this.activeElement) {
        return;
      }
      var parentElement = this.activeElement.getParentElement();
      if ( ! parentElement) {
        return;
      }

      var o = parentElement.getPageOffset();
      var scrollY = this.canvasBody.e.scrollTop;
      var scrollX = this.canvasBody.e.scrollLeft;

      switch (e.data.axis) {
        case 'x':
          this.xSnapGuide.setLeft(e.data.snap + o.left - scrollX);
          this.xSnapGuide.setHeight(this.pageBody.getHeight());
          this.xSnapGuide.show();
          break;
        case 'y':
          this.ySnapGuide.setTop(e.data.snap + o.top - scrollY);
          this.ySnapGuide.setWidth(this.pageBody.getWidth());
          this.ySnapGuide.show();
      }
    },

    notSnappedToContainer: function(e) {
      this[e.data.axis === 'x' ? 'xSnapGuide' : 'ySnapGuide'].hide();
    },

    pageUpdatedAndRefreshed: function() {
      this.sectionBoundaryManager.layoutChanged();
      this.pageBoundaryManager.layoutChanged();
      this.sectionBoundaryManager.setBoundaryVisibility();
      if (this.activeElement && ! this.activeElement.isVisibleOnPage()) {
        // NOTE: see LP-6713 and the page section visibility features in Aug 2014.
        this.setActiveElement(this.page.getRootElement());
      }
    },

    beforeBreakpointChanged: function (/*ev*/) {
      // the active element should always be blurred on breakpoint
      // changes to a) avoid model mutation bugs and b) to ensure
      // that the page properties panel and the enable responsive
      // checkbox is visible when a user switches to mobile for the
      // first time
      this.setActiveElement(this.page.getRootElement());
    },

    breakpointChanged: function() {
      this.updateCanvasLayout();
      this._updateBreakpointControls();
    },

    installSnapManager: function() {
      this.snapManager = new lp.editor.SnapManager(this);
      this.snapManager.addListener('snappedToContainer', this);
      this.snapManager.addListener('notSnappedToContainer', this);
    },

    addSolvvyEventListeners: function () {
      var self = this;
      document.addEventListener('solvvyLaunched', function() {
        self.keyController.sendKeyEvents = false;
      });
      document.addEventListener('solvvyClosed', function() {
        self.keyController.sendKeyEvents = true;
      });
    },

    installThirdParties: function() {
      if (ubBanzai.features.isGoogleSsoEnabled()) {
        installGoogleSSO();
      }

      if (ubBanzai.features.isAppCuesEnabled() && window.Appcues) {
        installAppcues();
      }

      this.installSnapManager();
      this.addSolvvyEventListeners();
    }

  });

})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/editor.js
// module id = 741
// module chunks = 0